export const localTimeToUTC = (
  dateString?: string | null
): string | undefined => {
  if (!dateString) return '';

  return new Date(dateString.replace(/Z$/, '')).toISOString();
};
